import { triggerFadeInExpandCollapseStatefulAnimation } from '../../../core/animations';

export const SavedAddressesComponentAnimations = [triggerFadeInExpandCollapseStatefulAnimation('animatedContent')];
